module.exports = __webpack_public_path__ + "media/images/basketball-image-0c5afff070601886c406bb67aee45e10.jpg";